"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nameToSlug = void 0;
function nameToSlug(name) {
    const withDashes = name.toLowerCase().replace(/\W+/g, "-");
    const withoutSurroundingDashes = withDashes.replace(/^[-|_]+/g, "").replace(/[-|_]+$/g, "");
    const shortended = withoutSurroundingDashes.substr(0, 38);
    const withoutSurroundingDashes2 = shortended.replace(/^[-|_]+/g, "").replace(/[-|_]+$/g, "");
    return withoutSurroundingDashes2;
}
exports.nameToSlug = nameToSlug;
//# sourceMappingURL=NameUtil.js.map